// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkSection-module--root--1a3fY","title":"LinkSection-module--title--2M_6H","titleLink":"LinkSection-module--titleLink--1_C4z","link":"LinkSection-module--link--YrUtc"};